import React from 'react';
import { WebsiteDesignProps } from './types';
import { Diamond, Crown, Sparkles, Gem } from 'lucide-react';
import { Button } from "@/components/ui/button";

const ArtDeco: React.FC<WebsiteDesignProps> = ({ previewData }) => {
    const schoolName = previewData?.name || "Gatsby Academy";

    return (
        <div className="bg-[#1a1a1a] text-[#e5c100] min-h-screen font-sans selection:bg-[#e5c100] selection:text-black border-8 border-[#1a1a1a]">
            <div className="border border-[#e5c100] min-h-[calc(100vh-16px)] relative p-2">
                <div className="border border-[#e5c100] min-h-full relative p-1">
                     
                     <nav className="flex justify-between items-center p-8 bg-[#1a1a1a] border-b border-[#e5c100]">
                         <div className="flex items-center gap-3">
                             <div className="border-2 border-[#e5c100] p-1 rotate-45">
                                 <div className="border border-[#e5c100] p-1">
                                     <Diamond size={20} className="fill-[#e5c100] text-[#e5c100] -rotate-45" />
                                 </div>
                             </div>
                             <span className="text-2xl font-light tracking-[0.2em] uppercase ml-4 text-[#e5c100]">{schoolName}</span>
                         </div>
                         <div className="hidden md:flex gap-12 font-bold uppercase text-xs tracking-[0.2em] text-[#bfa050]">
                             <a href="#" className="hover:text-white transition-colors">Society</a>
                             <a href="#" className="hover:text-white transition-colors">Academics</a>
                             <a href="#" className="hover:text-white transition-colors">Events</a>
                         </div>
                     </nav>

                     <main className="container mx-auto px-12 py-24 text-center">
                         <div className="w-16 h-16 mx-auto mb-8 border-2 border-[#e5c100] rounded-full flex items-center justify-center">
                             <Crown size={32} />
                         </div>
                         
                         <h1 className="text-6xl md:text-8xl font-light uppercase tracking-widest mb-12 text-transparent bg-clip-text bg-gradient-to-b from-[#e5c100] to-[#8a7200] leading-none">
                             The Golden <br/> Standard
                         </h1>

                         <div className="flex justify-center mb-16">
                              <div className="h-px w-32 bg-gradient-to-r from-transparent to-[#e5c100]"></div>
                              <div className="mx-4 text-xs uppercase tracking-[0.4em] text-[#bfa050]">Est. MCMXXII</div>
                              <div className="h-px w-32 bg-gradient-to-l from-transparent to-[#e5c100]"></div>
                         </div>

                         <div className="grid grid-cols-1 md:grid-cols-2 gap-16 max-w-5xl mx-auto items-center">
                              <div className="text-left">
                                  <h2 className="text-3xl font-light uppercase tracking-widest mb-6 text-white">Refined Elegance</h2>
                                  <p className="text-[#bfa050] leading-relaxed mb-8">
                                      We invite you to an educational experience defined by sophistication, luxury, and timeless tradition. Shape your destiny in style.
                                  </p>
                                  <Button variant="outline" className="border-[#e5c100] text-[#e5c100] hover:bg-[#e5c100] hover:text-black uppercase tracking-[0.2em] px-8 rounded-none transition-all">
                                      RSVP Now
                                  </Button>
                              </div>
                              <div className="relative">
                                  <div className="border-4 double border-[#e5c100] p-2">
                                      <img src="https://images.unsplash.com/photo-1514533248661-3896d8e82efd?q=80&w=3304&auto=format&fit=crop" className="w-full grayscale contrast-125 sepia-[.3]" alt="Classic" />
                                  </div>
                                  <div className="absolute -bottom-6 -right-6 w-24 h-24 border-t-2 border-l-2 border-[#e5c100]"></div>
                                  <div className="absolute -top-6 -left-6 w-24 h-24 border-b-2 border-r-2 border-[#e5c100]"></div>
                              </div>
                         </div>
                     </main>

                     {/* Footer Decoration */}
                     <div className="absolute bottom-0 left-0 w-full flex justify-between px-4 pb-4 pointer-events-none">
                         <div className="flex gap-2">
                             <div className="w-2 h-16 bg-[#e5c100]"></div>
                             <div className="w-2 h-10 bg-[#e5c100] self-end"></div>
                             <div className="w-2 h-6 bg-[#e5c100] self-end"></div>
                         </div>
                         <div className="flex gap-2">
                             <div className="w-2 h-6 bg-[#e5c100] self-end"></div>
                             <div className="w-2 h-10 bg-[#e5c100] self-end"></div>
                             <div className="w-2 h-16 bg-[#e5c100]"></div>
                         </div>
                     </div>
                </div>
            </div>
        </div>
    );
};

export default ArtDeco;
